<template>
    <div class="web-viewer">
        <div class="doc-container">
            <!-- Document viewer -->
            <div ref='viewer' class="doc-viewer">
            </div>
        </div>

        <!-- Analyses fields -->
        <div class="doc-analyses">
            <tabs :options="{ useUrlFragment: false }" cache-lifetime="0" @changed="onTabChanged" ref="tabs">
                <tab name="Fields">
                    <div class="fields" v-if="data != null">
                        <ul class="list-group">
                            <li class="list-group-item">DocType: <b>{{ docType }}</b></li>

                            <!-- Parties  -->
                            <li class="list-group-item" v-if="parties.length > 0">
                                <div @click="openParties = !openParties" class="cursor-pointer" :class="{ 'margin-bottom-10': openParties }">
                                    <span class="field-color-indicator" :style="{ backgroundColor: data.fields.Parties.color }"></span>
                                    Parties ({{ parties.length }})
                                    <i v-if="!openParties" class="icon-caret-down pull-right"></i>
                                    <i v-if="openParties" class="icon-caret-up pull-right"></i>
                                </div>
                                <div v-for="(item, key) in parties" :key="key" class="list-group-item" v-show="openParties">
                                    <div v-for="(val, fieldName) in item.valueObject" :key="fieldName" class="margin-top-10">
                                        <p class="secondary-text">{{ fieldName }}</p>
                                        <p class="field-content" @mouseover="setHighlights(val.boundingRegions)"
                                           @mouseleave="removeHighlights(val.boundingRegions)"><b>{{ val.content }}</b></p>
                                        <div v-if="val.type != 'string'" class="padding-15">
                                            <li v-for="(value, name) in val.valueAddress" :key="name" class="padding-bottom-10 list-unstyled">
                                                <p class="margin-bottom-5 text-capitalize secondary-text">{{ name }}</p>
                                                <p class="field-content" @mouseover="setHighlights(val.boundingRegions)"
                                                   @mouseleave="removeHighlights(val.boundingRegions)"><b>{{ value }}</b></p>
                                            </li>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <!-- Jurisdictions  -->
                            <li class="list-group-item" v-if="jurisdictions.length > 0">
                                <div @click="openJurisdictions = !openJurisdictions" :class="{ 'margin-bottom-10': openJurisdictions }"
                                     class="cursor-pointer">
                                    <span class="field-color-indicator" :style="{ backgroundColor: data.fields.Jurisdictions.color }"></span>
                                    Jurisdictions ({{ jurisdictions.length }})
                                    <i v-if="!openJurisdictions" class="icon-caret-down pull-right"></i>
                                    <i v-if="openJurisdictions" class="icon-caret-up pull-right"></i>
                                </div>
                                <div v-for="(item, key) in jurisdictions" :key="key" class="list-group-item" v-show="openJurisdictions">
                                    <div v-for="(val, fieldName) in item.valueObject" :key="fieldName" class="margin-top-10">
                                        <p class="secondary-text">{{ fieldName }}</p>
                                        <p class="field-content" @mouseover="setHighlights(val.boundingRegions)"
                                           @mouseleave="removeHighlights(val.boundingRegions)"><b>{{ val.content }}</b></p>
                                    </div>
                                </div>
                            </li>

                            <!-- Fields  -->
                            <li v-for="(value, key) in fields" :key="key" class="list-group-item">
                                <div v-if="value.type != 'array'">
                                    <p class="text-left">
                                        <span class="field-color-indicator" :style="{ backgroundColor: value.color }"></span>
                                        {{ key }}
                                        <span v-for="(data, index) in value.boundingRegions" :key="index" class="badge">
                                            #
                                            {{ data.pageNumber }}
                                        </span> <span class="pull-right">{{ value.confidence }}</span>
                                    </p>
                                    <p class="field-content padding-left-20" @mouseover="setHighlights(value.boundingRegions)"
                                       @mouseleave="removeHighlights(value.boundingRegions)"><b>{{ value.content }}</b></p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="text-center center-div" v-if="data === null">
                        <h4>Run anaysis on this document to see the results</h4>
                        <button @click="runAnalysis" :disabled="file == null">Run analysis</button>
                    </div>
                </tab>
                <tab name="Content" class="padding-20">
                    <!-- Paragraphs -->
                    <div v-if="pdfData != null" class="card" v-for="(item, key) in paragraphs" :key="key"
                         @mouseover="setHighlights(item.boundingRegions)" @mouseleave="removeHighlights(item.boundingRegions)">
                        <div class="card-title text-capitalize"> {{ item.role ? item.role : 'Paragraph' }}</div>
                        <div>{{ item.content }}</div>
                    </div>
                    <!-- No pdf data -->
                    <div class="text-center center-div" v-if="pdfData === null">
                        <h4>Run anaysis on this document to see the results</h4>
                        <button @click="runAnalysis" :disabled="file == null">Run analysis</button>
                    </div>
                </tab>
                <tab name="Result">
                    <json-viewer v-if="pdfData != null" :value="pdfData" copyable></json-viewer>
                    <!-- No pdf data -->
                    <div class="text-center center-div" v-if="pdfData === null">
                        <h4>Run anaysis on this document to see the results</h4>
                        <button @click="runAnalysis" :disabled="file == null">Run analysis</button>
                    </div>
                </tab>
            </tabs>
        </div>
    </div>
</template>

<script>
    import WebViewer from '@pdftron/pdfjs-express';
    export default {
        name: "web-viewer",
        components: {
        },
        props: {
            file: File
        },
        data: () => {
            return {
                docViewer: null,
                annotManager: null,
                annotations: null,
                pdfData: null,
                data: null,
                docType: null,
                fields: null,
                parties: [],
                jurisdictions: [],
                openParties: false,
                openJurisdictions: false,
                paragraphs: [],
                colors: ['#dd4331', '#8bae11', '#ffab3f', '#005269', '#008080', '#e27100', '#800080', '#007efc']
            }
        },
        watch: {
            file: {
                handler: function (newFile) {
                    if (newFile && this.docViewer) {
                        this.openFile(newFile);
                        this.resetData();
                    }
                },
                deep: true,
            },
        },
        mounted: function () {
            WebViewer({
                path: '/assets/webviewer',
                extension: 'pdf',
                disableFlattenedAnnotations: true,
                disabledElements: ['contextMenuPopup',
                    'toolsHeader',
                    'ribbons',
                    'toggleNotesButton',
                    'languageButton',
                    'textPopup',
                    'selectToolButton',
                    'leftPanelButton',
                    'viewControlsButton',
                    'freeHandToolGroupButton',
                    'textToolGroupButton',
                    'shapeToolGroupButton',
                    'eraserToolButton',
                    'signatureToolButton',
                    'freeTextToolButton',
                    'stickyToolButton',
                    'miscToolGroupButton',
                    'searchButton',
                    'annotationPopup',
                    'annotationStylePopup',
                    'viewControlsOverlay']
            }, this.$refs.viewer).then((instance) => {
                this.docViewer = instance.Core.documentViewer;
                if (this.file) this.openFile(this.file);
                this.annotManager = instance.Core.annotationManager;
                this.annotations = instance.Annotations;
            });
        },
        methods: {
            /**
             * Open document in viewer
             */
            openFile(file) {
                this.docViewer.loadDocument(file, { filename: file.name });
            },
            /**
             * Reset document data
             */
            resetData() {
                this.pdfData = null;
                this.data = null;
                this.docType = null;
                this.fields = null;
                this.parties = [];
                this.jurisdictions = [];
                this.paragraphs = [];
                this.openParties = false;
                this.openJurisdictions = false;
            },
            /**
             * Analyse contract document
             */
            runAnalysis() {
                app.notifications.showLoading("Running analysis...");
                var formData = new FormData();
                formData.append("file", this.file);
                app.api.Contract.analyze(formData,
                    (result) => {
                        app.notifications.hideLoading();
                        var response = JSON.parse(result);
                        if (response.analyzeResult.documents.length === 0) {
                            app.notifications.showErrorMsg('There is no data for the uploaded document.', { duration: 3000 });
                            return;
                        }
                        this.pdfData = response;
                        this.data = this.pdfData.analyzeResult.documents[0];
                        this.setContractData();
                    },
                    (error) => {
                        app.notifications.hideLoading();
                        app.notifications.showErrorMsg(error.message, { duration: 3000 });
                    });
            },
            /**
             * Set data
             */
            setContractData() {
                this.docType = this.data.docType;
                // set color to each field
                Object.entries(this.data.fields).forEach(([key, value], index) => {
                    value.color = this.colors[index];
                });
                this.fields = { ...this.data.fields };
                delete this.fields.Parties;
                delete this.fields.Jurisdictions;
                this.parties = this.data.fields.Parties ? this.data.fields.Parties.valueArray : [];
                this.jurisdictions = this.data.fields.Jurisdictions ? this.data.fields.Jurisdictions.valueArray : [];
                this.paragraphs = this.pdfData.analyzeResult.paragraphs ? this.pdfData.analyzeResult.paragraphs : [];
                this.deleteAnnotations();
                var activeTab = this.$refs.tabs.$children.find(child => child.isActive);
                if (activeTab.name === 'Content') {
                    this.setContractParagraphs();
                } else this.setFieldsTabData();
            },
            /**
             * Set fields tab data
             */
            setFieldsTabData() {
                this.setContractFields();
                if (this.parties.length > 0) this.setContractParties();
                if (this.jurisdictions.length > 0) this.setContractJurisdictions();
            },
            /**
             * Set contract parties
             */
            setContractParties() {
                this.parties.forEach((item, index) => {
                    Object.entries(item.valueObject).forEach(([key, value]) => {
                        value.boundingRegions.forEach((reg, regidx) => {
                            reg.id = 'parties' + index + key + regidx;
                            var coords = this.getPolygonCoordinates(reg);
                            this.createAnotations(coords, reg.id, reg.pageNumber, this.data.fields.Parties.color);
                        })
                    });
                });
            },
            /**
             * Set contract jurisdictions
             */
            setContractJurisdictions() {
                this.jurisdictions.forEach((item, index) => {
                    Object.entries(item.valueObject).forEach(([key, value]) => {
                        value.boundingRegions.forEach((reg, regIdx) => {
                            reg.id = 'jurisdictions' + index + key + regIdx;
                            var coords = this.getPolygonCoordinates(reg);
                            this.createAnotations(coords, reg.id, reg.pageNumber, this.data.fields.Jurisdictions.color);
                        })
                    });
                });
            },
            /**
             * Set contract fields (dates, title)
             */
            setContractFields() {
                Object.entries(this.fields).forEach(([key, value]) => {
                    value.boundingRegions.forEach((reg, index) => {
                        reg.id = key + index;
                        var coords = this.getPolygonCoordinates(reg);
                        this.createAnotations(coords, reg.id, reg.pageNumber, value.color);
                    })
                });
            },
            /**
             * Set contract content (paragraphs, sections)
             */
            setContractParagraphs() {
                this.paragraphs.forEach((paragraph, index) => {
                    paragraph.boundingRegions.forEach((reg, regidx) => {
                        reg.id = 'paragraphs-' + index + '-' + regidx;
                        var coords = this.getPolygonCoordinates(reg);
                        this.createAnotations(coords, reg.id, reg.pageNumber, '#4798ce');
                    })
                })
            },
            /**
             * Calculate x,y coordinates, width and height of the polygon
             */
            getPolygonCoordinates(region) {
                let polygon = this.inchesToPoints(region.polygon);
                let width = polygon[2] - polygon[0];
                let height = polygon[5] - polygon[1];
                let rectangle = { x: polygon[0], y: polygon[1], width, height }
                return rectangle;
            },
            /**
             * Convert inches to points
             */
            inchesToPoints(polygon) {
                let points = [];
                polygon.forEach(value => {
                    points.push(value * 72);
                });
                return points;
            },
            /**
             * Create rectangle annotations
             */
            createAnotations(rect, id, pageNumber, color) {
                const rectangleAnnot = new this.annotations.RectangleAnnotation();
                rectangleAnnot.PageNumber = pageNumber;
                // values are in page coordinates with (0, 0) in the top left
                rectangleAnnot.X = rect.x;
                rectangleAnnot.Y = rect.y;
                rectangleAnnot.Width = rect.width;
                rectangleAnnot.Height = rect.height;
                rectangleAnnot.StrokeColor = new this.annotations.Color(color);
                rectangleAnnot.StrokeThickness = 2;
                rectangleAnnot.ReadOnly = true;
                rectangleAnnot.Id = id;
                this.annotManager.addAnnotation(rectangleAnnot);
                // need to draw the annotation otherwise it won't show up until the page is refreshed
                this.annotManager.redrawAnnotation(rectangleAnnot);
            },
            /**
             * Highlight annotations for each bounding region
             */
            setHighlights(regions) {
                this.scrollToAnnotation(regions);
                regions.forEach(reg => {
                    this.highlightAnnotation(reg.id)
                });
            },
            /**
             * Remove annotation highlight for each bounding region
             */
            removeHighlights(regions) {
                regions.forEach(reg => {
                    this.revertAnnotation(reg.id)
                });
            },
            /**
             * Highlight annotation on field cover
             */
            highlightAnnotation(id) {
                let annotation = this.annotManager.getAnnotationById(id);
                annotation.StrokeThickness = 4;
                this.annotManager.redrawAnnotation(annotation);
            },
            /**
             * Revert highlighted annotation
             */
            revertAnnotation(id) {
                let annotation = this.annotManager.getAnnotationById(id);
                annotation.StrokeThickness = 2;
                this.annotManager.redrawAnnotation(annotation);
            },
            /**
             * Scroll document to annotation
             */
            scrollToAnnotation(regions) {
                let isOnPage = false;
                regions.forEach(reg => {
                    if (reg.pageNumber === this.docViewer.getCurrentPage()) isOnPage = true;
                });
                if (!isOnPage) {
                    var coords = this.inchesToPoints(regions[0].polygon);
                    this.docViewer.displayPageLocation(regions[0].pageNumber, coords[0], coords[1], true);
                }
            },
            /**
             * New tab clicked
             */
            onTabChanged(selectedTab) {
                if (!this.annotManager || this.pdfData === null) return;
                var tabName = selectedTab.tab.name;
                if (tabName === 'Content') {
                    this.deleteAnnotations();
                    this.setContractParagraphs();
                } else {
                    this.deleteAnnotations();
                    this.setFieldsTabData();
                }
            },
            /**
             * Delete all annotations
             */
            deleteAnnotations() {
                var annotList = this.annotManager.getAnnotationsList();
                this.annotManager.deleteAnnotations(annotList, false, true);
            }
        }
    };
</script>
<style scoped>
    @import '~/styles/plugins/tabs-component.css';

    .web-viewer {
        width: 100%;
        display: flex;
    }

    .doc-container {
        width: 70%;
    }

    .doc-viewer {
        height: calc(100vh - 40px);
    }

    .doc-analyses {
        width: 30%;
        border-left: 1px solid #e0e0e0;
    }

    .fields .list-group .list-group-item:not(:first-of-type) {
        border-top: 1px solid #e0e0e0;
    }

    .fields {
        padding: 10px;
        text-align: left;
    }

    .field-content {
        margin-bottom: 0;
    }

        .field-content:hover {
            background-color: #f1f1f1;
        }

    .field-color-indicator {
        width: 13px;
        height: 13px;
        display: inline-block;
        border-radius: 50%;
        margin-right: 3px;
    }

    .center-div {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .card {
        padding: 15px;
        background: #f1f3f5;
        margin-bottom: 20px;
    }

        .card .card-title {
            font-weight: bold;
            border-bottom: 1px solid lightgray;
            margin-bottom: 10px;
            padding-bottom: 10px;
        }
</style>



// WEBPACK FOOTER //
// WebViewer.vue?9ee1184a